/**
 *  匯出 CSV 功能
 */

import exportFromJSON from 'export-from-json'
import moment from 'moment'

import global from './global'
import functions from './functions'

const columnNames = ['組別', '報名人', '歌曲', '學校', 'Email', '電話', '報名時間', '設備', '效果器', '備註', '團員', '繳費代碼', '分數', '評語', '繳費狀態', '虛擬ATM帳號'] // 預設會匯出的所有欄位名稱列表

const requiredColumnNames = ['報名人']

/**
 * 取得檔案名稱
 * @param  {String} school    學校/比賽名稱
 * @param  {String} formGroup 組別名稱
 * @return {String}           檔名
 */
const getFileName = (school, group) => {
  const timeText = moment().format('YYYYMMDDHHmmss') // 當前時間(數字表示)
  let result = school

  result += group ? '_' + group : ''
  result += '_' + timeText

  return result
}

/**
 * 匯出 CSV
 * @param {Array}  forms   表單列表
 * @param {Array}  headers 在`報名表單`頁面表格的欄位標題列表
 * @param {Object} options 選項
 */
const csv = (forms, headers, options) => {
  const schoolName = options.schoolName || 'MCIP_Forms' // 學校/比賽名稱
  const formGroupName = functions.convertGroupText(options.formGroupId) // 組別名稱
  const fileName = getFileName(schoolName, formGroupName) // 檔案名稱
  const exportType = 'csv' // 匯出格式
  const columns = options.columns || columnNames // 指定欲匯出的欄位

  const data = forms.map(item => {
    let row = {} // 單行(筆)表單的資料

    headers.forEach(col => { row[col.text] = item[col.value] }) // 插入在表格就可見的基本欄位
    delete row[''] // 清除欄位名稱為空白的項

    // 插入點擊才展開的的其他欄位
    const 組別 = functions.convertGroupText(item.group)
    const 報名時間 = moment(item.timestamp).format('YYYY/MM/DD HH:mm:ss')
    const 分數 = item.comment ? item.comment.score : ''
    const 評語 = item.comment ? item.comment.content : ''
    const 繳費狀態 = item.status ? functions.convertFormStatusObject(item.status).name : ''
    const 繳費代碼 = item.code ? item.code : ''
    const 團員 = item.partners?.length
      ? item.partners.join(', ') // 以逗號串接團員文字
      : ''

    // 處理設備欄位
    const 設備List = Object.keys(item.equipment)
      // 將設備物件轉換為陣列
      .map(key => {
        const name = functions.convertEquipmentText(key)
        const value = item.equipment[key]
        return { name, value, key }
      })
      .filter(_ => !global.uncountableEquipmentList.some(i => i === _.key) && +_.value) // 排除不可數的設備和值為 0 者
      .sort((a, b) => a.name < b.name ? 1 : -1) // 按照設備名排序

    // 處理後的設備文字
    const 設備 = (設備List && 設備List.length > 0)
      ? 設備List
        .map(_ => `${_.name}: ${_.value}`) // 各個設備文字格式(名稱: 數量)
        .join(', ') // 以逗號串接設備文字
      : ''

    const 效果器 = item.equipment ? item.equipment.effector : ''
    const 備註 = item.equipment ? item.equipment.other : ''

    const 虛擬ATM帳號 = item.payment?.vAccount ? item.payment?.vAccount : ''

    row = { ...row, 組別, 報名時間, 設備, 效果器, 備註, 團員, 繳費狀態, 繳費代碼, 分數, 評語, 虛擬ATM帳號 }

    const newRow = {} // 最終匯出的單行(筆)表單的資料
    columns.forEach(item => { newRow[item] = row[item] }) // 挑出已選的欄位

    // 處理共同欄位
    if (Array.isArray(item.commonField) && options.isExportCommonField) {
      item.commonField.forEach(_ => { newRow[_.label] = _.value })
    }

    // 處理自定義欄位
    if (Array.isArray(item.customField) && options.isExportCustomField) {
      item.customField.forEach(_ => { newRow[_.label] = _.value })
    }

    return newRow
  })
  exportFromJSON({ data, fileName, exportType })
}

export default {
  columnNames,
  requiredColumnNames,
  csv,
}
